<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <DailySignupAnalysisTable/>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
  import DailySignupAnalysisTable from './DailySignupAnalysisTable.vue'

  export default {
    name: 'daily-signup-analysis-table',
    components: { DailySignupAnalysisTable }
  }
</script>



// WEBPACK FOOTER //
// src/views/report/risk/DailySignupAnalysis.vue